module.exports = __webpack_public_path__ + "static/media/tf.3f87ed91.svg";